module.exports = __webpack_public_path__ + "img/pending-bg.1c501a69.png";